import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Fab from '../../components/Fab/Fab';


const propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const UserReportAdd = ({ history }) => {
  let element = null;
  const { pathname } = history.location;
  if (pathname === '/users' || pathname === '/reports') {
    const nextPath = `${pathname}/add`;
    element = (
      <Fab onClick={() => history.push(nextPath)} />
    );
  }
  return element;
};

UserReportAdd.propTypes = propTypes;
export default withRouter(UserReportAdd);



// WEBPACK FOOTER //
// ./src/containers/UserReportAdd/UserReportAdd.js